import { DropdownOption as FluentDropdownOption } from "@fluentui/web-components";
/**
 * DropdownOption
 * @summary A DropdownOption Custom HTML Element based on Fluent UI's DropdownOption with custom styling and behavior.
 *
 * @example
 * ```html
 * <fabric-option>
 *   <span slot="checked-indicator">✔</span>
 *   Option Label
 *   <span slot="description">Detailed description</span>
 * </fabric-option>
 * ```
 *
 * @attr {boolean} current-selected - Indicates the current selected state of the option.
 * @attr {boolean} selected - Sets the selected property to match the currentSelected state.
 * @attr {boolean} disabled - Toggles the disabled state when the user changes the `disabled` property.
 * @attr {string} form - The associated `<form>` element.
 * @attr {boolean} freeform - Indicates if the option is in a freeform input mode.
 * @attr {string} id - The id of the option. If not provided, a unique id will be assigned.
 * @attr {string} value - The initial value of the option.
 * @attr {boolean} multiple - Indicates that the option is in a multiple selection mode context.
 * @attr {string} name - The name of the option.
 * @attr {string} text - The display text of the option.
 *
 * @prop {boolean} active - Indicates that the option is active.
 * @prop {ElementInternals} elementInternals - The internal ElementInternals instance for the component.
 *
 * @slot checked-indicator - Customizable checked indicator slot.
 * @slot - Default slot for the option label.
 * @slot description - Slot for detailed option description.
 * @slot start - Icon or glyph rendered before the main label.
 *
 * @csspart content - The main content container of the option.
 * @csspart description - The container for the option's description.
 *
 * @method toggleSelected - Toggles the selected state of the control.
 *
 * @extends FluentDropdownOption
 * @tagname fabric-option
 * @public
 */
export class DropdownOption extends FluentDropdownOption {
}
//# sourceMappingURL=option.js.map